import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.contextmenu');
import { OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-contextmenu',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.contextmenu/view.scss */
:host {
  display: block;
}

.context-menu {
  animation: ctxFadeIn 0.12s ease-out;
}

.context-menu.context-menu-closing {
  animation: ctxFadeOut 0.12s ease-in forwards;
}

@keyframes ctxFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes ctxFadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}`],
})
export class ComponentContextmenuComponent implements OnInit {
    private _show: boolean = false;
    public isVisible: boolean = false;
    public isClosing: boolean = false;

    @Input() set show(val: boolean) {
        if (this._show && !val) {
            this.isClosing = true;
            setTimeout(() => {
                this.isVisible = false;
                this.isClosing = false;
                this._show = false;
            }, 120);
        } else if (val) {
            this._show = true;
            this.isVisible = true;
            this.isClosing = false;
        } else {
            this._show = val;
        }
    }
    get show(): boolean { return this._show; }

    @Input() x: number = 0;
    @Input() y: number = 0;
    @Input() isMe: boolean = false;

    @Output() ctxInfo = new EventEmitter<void>();
    @Output() ctxNote = new EventEmitter<void>();
    @Output() ctxWhisper = new EventEmitter<void>();
    @Output() ctxPoke = new EventEmitter<void>();
    @Output() ctxMyInfo = new EventEmitter<void>();
    @Output() ctxClose = new EventEmitter<void>();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (this.isVisible && !this.isClosing && !target.closest('.context-menu')) {
            this.ctxClose.emit();
        }
    }

    public onInfo() { this.ctxInfo.emit(); }
    public onNote() { this.ctxNote.emit(); }
    public onWhisper() { this.ctxWhisper.emit(); }
    public onPoke() { this.ctxPoke.emit(); }
    public onMyInfo() { this.ctxMyInfo.emit(); }
}

export default ComponentContextmenuComponent;